import Button from './Button.vue';

export default Button;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/info/components/button/index.ts